import React, {FC, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {selectMetadata} from 'entities/metadata';
import {resetLoadedData} from 'modules/data';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';
import {TModalComponentInterface} from 'store/slices/modals-slice';

import {FormModalWrapper} from '../form-modal/form-modal-wrapper';
import {FormEditContent} from './form-edit-content';

import '../form-modal/form-modal.less';

interface IFormEditEntityProps extends TModalComponentInterface {
    entityName: string;
    entityType?: EEntityType;
    referenceUrl?: string;
    forceHasTitle?: boolean;
    resetEntityName?: string;
    resetEntityType?: EEntityType;
}

export const FormEditModal: FC<IFormEditEntityProps> = ({
    onClose,
    entityName,
    entityType = EEntityType.FORM,
    referenceUrl,
    forceHasTitle,
    resetEntityName,
    resetEntityType,
}: IFormEditEntityProps) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const metadataSelector = selectMetadata(entityName, entityType);
    const [shouldResetTable, setShouldResetTable] = useState(false);

    const meta = useAppSelector(state => metadataSelector(state));

    const handleModalClose = () => {
        onClose();
        if (shouldResetTable && meta.tableEntityName) dispatch(resetLoadedData(meta.tableEntityName, EEntityType.TABLE));
        setShouldResetTable(false);
    };

    return (
        <FormModalWrapper
            hasTitle={forceHasTitle ? true : !!meta?.title}
            onClose={handleModalClose}
            entityName={entityName}
        >
            {handleClose => (
                <FormEditContent
                    url={referenceUrl || ''}
                    entityName={entityName}
                    entityType={entityType}
                    onClose={handleClose}
                    resetEntityName={resetEntityName || location.pathname.slice(1)}
                    resetEntityType={resetEntityType}
                    setShouldResetTable={setShouldResetTable}
                />
            )}
        </FormModalWrapper>
    );
};
